import {React, forwardRef} from 'react'
import '../components/HomeAbout.css';

// const HomeAbout = forwardRef(( props, ref) => {
const HomeAbout = ({ setImageCount }) => {

     const onImgLoad = () => {
        setImageCount(prev => prev + 1);
    };


    return (
    <section  className="about">
        <div className="container">
            <h1 className='fs-100 heading' >
                <span className='text-primary' >We are dedicated</span> to upholding industry standards and implementing best practices across every project.
            </h1>
       
            <div className="flex flex-col xl:flex-row gap-10 mt-20 align-middle">
                <div className="w-full xl:w-1/3">
                    <img src="/assets/img/home/about.png" alt="We are dedicated" onLoad={onImgLoad}  />
                </div>
                <div className="w-full xl:w-2/3 flex align-middle">
                    <div>
                        <div className="fs-30 font-extralight ">
                            <span className="">
                                Our values define our work ethic and guide every decision we make. We take pride in upholding the highest quality because our clients deserve nothing less.
                            </span>
                        </div>
                        <div className="fs-24 mt-10 ">
                            <span className='text-primary font-light'>A professional approach to every project</span> 
                            <span className="font-extralight"> is non-negotiable for our team. We constantly explore every possible direction to ensure the best outcome</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
  )
};

export default HomeAbout
